import { render, staticRenderFns } from "./EditReportPage.vue?vue&type=template&id=4e467341&scoped=true&"
import script from "./EditReportPage.vue?vue&type=script&lang=ts&"
export * from "./EditReportPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e467341",
  null
  
)

export default component.exports